import {CommonProps} from './types';

const RSSSmall = ({
  color = 'currentColor',
  size = 14,
  ...rest
}: CommonProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1 11a2 2 0 104 0 2 2 0 00-4 0zM1 5.32A6.04 6.04 0 018.68 13M1 1.2A10.01 10.01 0 0112.8 13"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RSSSmall;
